<div class="content">
  <video #video src="/assets/video/voice-instructions.mp4" autoplay muted (play)="handlePlay()" (ended)="handleEnded()"></video>
  @if (!started) {
    <button class="play-container" (click)="play()" (keypress)="play()">
      <mat-icon class="mat-icon-fill">play_arrow</mat-icon>
    </button>
  }
</div>
